export const LIB_VERSION = '17.0.1'; // autogenerated 
//# sourceMappingURL=version.js.map